import {
  FaCalendarCheck,
  FaPlaneDeparture,
} from "react-icons/fa6";

const MenuStaff = [
  {
    label: "Schedule",
    to: "schedule",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
];

export default MenuStaff;
